import { MoreVert } from '@mui/icons-material';
import { IconButton, Menu as MuiMenu } from '@mui/material';

import React, { useState } from 'react';

import { MenuActions } from 'app/components/MenuActions';

interface Props {
  handleEdit: () => void;
  handleDelete: () => void;
}

export const Menu = ({ handleEdit, handleDelete }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const menuOpen = Boolean(anchorEl);

  const handleSettingsMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
    event.preventDefault();
  };
  const handleSettingsMenuClose = (event: React.MouseEvent) => {
    setAnchorEl(null);
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <>
      <IconButton
        aria-label="settings"
        onClick={e => {
          handleSettingsMenuClick(e);
        }}
      >
        <MoreVert />
      </IconButton>
      <MuiMenu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleSettingsMenuClose}
        className="event-card__menu"
      >
        <MenuActions
          handleEdit={e => {
            handleEdit();
            handleSettingsMenuClose(e);
          }}
          handleDelete={e => {
            handleDelete();
            handleSettingsMenuClose(e);
          }}
        />
      </MuiMenu>
    </>
  );
};
